import { ExpertAnketaQuestionRate } from './ExpertAnketaQuestionRate';

export default ExpertAnketaQuestionRate;